// loads scripts that need to be on page - every entrypoint should import this!
// import { AdLoader, lazyload } from '@datagraphics/cookbook';

// Import packages
// Utils
import { initFrameAndPoll } from '@newswire/frames';
import { loadJsonScript } from './utils/load-json-script';
import ConservationMap from './components/ConservationMap.svelte';

initFrameAndPoll();
async function main() {
  const savingsByRegion = loadJsonScript('conservation-by-region');
  new ConservationMap({
    target: document.getElementById('conservation-map'),
    props: {
      title: 'Cumulative water use by hydrologic region',
      data: savingsByRegion,
      showTitle: false,
      legendHeight: 50,
    },
  });
}

main().catch(console.error);
